import React, { Fragment, useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  getRegistrationsByFilter,
  getAllRegistrations,
  updateExaminationStatus
} from "../../api/admissionApi";
import moment from "moment";
import LoaderSpinner from "../../common/LoaderSpinner";
import Popup from "../../Shared/Popup";

export default function UpdateExamStatus(props = {}) {
  const {
    isEdit = false,
    isCreate = false,
    verifyAndSearchUser,
    verificationSuccess,
    searchingUser,
    userInformation = {},
    currentUser,
    setActiveTab,
    // existingDA,
    existingSalaryConfig = {},
    editorId = "",
    history,
    isUpdating,
    permissions = {},
    activeTab,
  } = props;
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const {
    authenticationReducer: {
      studentProfile: { is_registration_completed, email_id, formNumber },
      isStudent, faculty_id
    } = {},
    admissionReducer: { isUserProfileLoading = false, filteredReg = [], fetchingReg } = {},
  } = state || {};
  const getAllStudentRegistrations = (ecb) => dispatch(getAllRegistrations(ecb));
  const updateExamStatus = (data, cbs) => dispatch(updateExaminationStatus(data, cbs));

  useEffect(()=> {
    fetchDefaultList();
  }, [])

  const fetchDefaultList = () => {
    //if we want only the paid list of students
    const payload = {
      paymentStatus: 'paid'
    };
    dispatch(getRegistrationsByFilter(payload, errorCallback));

  //if we want complete list of paid and unpaid students
  // getAllStudentRegistrations(errorCallback);
  }

  const errorCallback = (err) => {
    if(err?.data?.registrations === "No registrations found with provided filters")  toast.error(err.data.registrations, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    });
    else
    toast.error("Invalid filters passed!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    });
  }

  const updateExamStatusHandler = (obj, actionType, index) => {
    if(obj.payment_status.isCollegeFeePaid && faculty_id){
        const payload = {
            formNumber: obj.formNumber,
            status: actionType,
            createdBy: faculty_id
        };
        const callbacks = {
            successCallback: (response) => {
              toast.success(response.message);
              fetchDefaultList();
            },
            failureCallback: (errData) => {
                toast.error(errData.message)
            }
        };
        updateExamStatus(payload, callbacks)
    }
    
  }

  const renderRegistrartions = () => {
    if (!filteredReg.length) return null;
    return (
      <div className="table-responsive card">
        <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
          <thead>
            <tr>
              <th style={{ borderRight: "1px solid #eee" }}>Form No.</th>
              <th style={{ borderRight: "1px solid #eee" }}>Name</th>
              <th style={{ borderRight: "1px solid #eee" }}>Email Id</th>
              <th style={{ borderRight: "1px solid #eee" }}>Phone</th>
              <th style={{ borderRight: "1px solid #eee" }}>Reg. status</th>
              <th style={{ borderRight: "1px solid #eee" }}>College fees payment status</th>
              <th style={{ borderRight: "1px solid #eee" }}>Fees paid date</th>
              <th style={{ borderRight: "1px solid #eee" }}>Transaction Id</th>
              <th style={{ borderRight: "1px solid #eee" }}>Update examination status</th>
            </tr>
          </thead>
          <tbody>
            {filteredReg.map((reg = {}, idx) => {
              const { full_name: { first_name = '', last_name = '' } = {} } = reg;
              return (
                <tr key={idx}>
                  <td style={{ textAlign: "center", borderRight: "1px solid #eee" }}>{reg.formNumber ? reg.formNumber : '-'}</td>
                  <td style={{ borderRight: "1px solid #eee" }}><span className="font-16">{`${first_name} ${last_name}`}</span></td>
                  <td style={{ borderRight: "1px solid #eee" }}>{reg.email_id}</td>
                  <td style={{ textAlign: "center", borderRight: "1px solid #eee" }}>{reg.mobile_number}</td>
                  <td style={{ borderRight: "1px solid #eee" }}>
                    {reg.is_registration_completed ? <span style={{ background: 'limegreen' }}>{'Complete'}</span> : <span style={{ background: 'yellow' }}>{'Pending'}</span>}
                  </td>
                  <td style={{ textAlign: "center",  borderRight: "1px solid #eee" }}>
                    {/* {reg.payment_status?.isCollegeFeePaid ? <span style={{ background: 'limegreen' }}>{'Paid & Verified'}</span> : <span style={{ background: 'yellow' }}>{'Un-Paid'}</span>} */}
                    {
                      (reg.payment_status?.isCollegeFeePaid && reg.payment_status?.collegeFeesPaidDate) ? <span style={{ background: 'limegreen' }}>{`Paid & Verified`}</span>:
                      (reg.payment_status?.isCollegeFeePaid && !reg.payment_status?.collegeFeesPaidDate) ? <span>Paid</span> :
                      <span>{`Un-Paid`}</span>
                    }
                  </td>
                  <td style={{ borderRight: "1px solid #eee" }}>
                    {reg.payment_status?.isCollegeFeePaid === true && moment(reg.payment_status?.collegeFeesPaidDate).format("YYYY-MM-DD HH:MM")}
                  </td>
                  <td style={{ borderRight: "1px solid #eee" }}>
                    {reg.payment_status?.isCollegeFeePaid === true && reg.payment_status?.collegeFeePaidTransactionId ? reg.payment_status?.collegeFeePaidTransactionId : "DD payment"}
                  </td>
                  <td>
                  {/* {reg.examination_status?.is_examination_passed === true ? <span className="mr-10" style={{ background: 'limegreen' }}>{'Passed'}</span> : reg.examination_status?.is_examination_passed === false ? <span className="mr-10" style={{ background: 'limegreen' }}>{'Failed'}</span> : 
                  <Fragment>
                      <button disabled={!reg.payment_status?.isCollegeFeePaid} type="button" className="btn btn-outline-primary mr-10" onClick={()=> updateExamStatusHandler(reg, true, idx)}>Pass</button>
                      <button disabled={!reg.payment_status?.isCollegeFeePaid} type="button" className="btn btn-outline-danger" onClick={()=> updateExamStatusHandler(reg, false, idx)}>Fail</button>
                    </Fragment>} */}

                  {
                    reg.examination_status?.is_examination_passed === true ? <span className="mr-10" style={{ background: 'limegreen' }}>{'Passed'}</span> : 
                    <button disabled={!reg.payment_status?.isCollegeFeePaid} type="button" className="btn btn-outline-primary mr-10" onClick={()=> updateExamStatusHandler(reg, true, idx)}>Pass</button>
                  }
                  {
                    reg.examination_status?.is_examination_passed === false ? <span className="mr-10" style={{ background: 'limegreen' }}>{'Failed'}</span> : 
                    <button disabled={!reg.payment_status?.isCollegeFeePaid} type="button" className="btn btn-outline-danger" onClick={()=> updateExamStatusHandler(reg, false, idx)}>Fail</button>
                  }
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  const renderHeader = () => {
    return (
      <Fragment>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">
                  Update Examination status
                </h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href>St. Andrews College</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                  Update Examination status for students
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderContent = () => {
    return (
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">
            Update the examination status for student(s)
          </h3>
        </div>
        <div className="pl-20">
          Below are the filtered students list who have already paid the college fees:
         {fetchingReg && <LoaderSpinner />}
        </div>
        <div className="card-body">
          {renderRegistrartions()}
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      {renderHeader()}
      <div className="section-body mt-4">
        <div className="container-fluid">{renderContent()}</div>
      </div>
      <ToastContainer />
    </Fragment>
  );
}
